import { render, staticRenderFns } from "./AccountSettingTwoFactor.vue?vue&type=template&id=2c22e791&"
import script from "./AccountSettingTwoFactor.vue?vue&type=script&lang=js&"
export * from "./AccountSettingTwoFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports